import React, { useState } from "react";
import { string, shape, arrayOf } from "prop-types";

const propTypes = {
  contactInfo: arrayOf(
    shape({
      title: string.isRequired,
      items: arrayOf(
        shape({
          label: string.isRequired,
          text: string.isRequired,
          href: string,
        }),
      ).isRequired,
    }),
  ),
};

const ContactForm = (props) => {
  const { contactInfo } = props;

  const [activeContactInfo, setActiveContactInfo] = useState(0);

  return (
    <section className="contact-form">
      <div className="container container--50-50">
        <form autoComplete="off">
          <label className="contact-form__label" htmlFor="contact-select">
            Select a name:
          </label>
          <select
            className="contact-form__select"
            value={activeContactInfo}
            onChange={(e) => setActiveContactInfo(e.target.value)}
            name="contact-select"
            id="contact-select"
          >
            {contactInfo.map((item, i) => (
              <option key={i} value={i}>
                {item.title}
              </option>
            ))}
          </select>
        </form>
        <div className="contact-form__contact-info">
          <h2 className="contact-form__info-header">
            {contactInfo[activeContactInfo].title}
          </h2>
          <dl>
            {contactInfo[activeContactInfo].items.map((item, i) => (
              <React.Fragment key={i}>
                <dt>{item.label}</dt>
                <dd>
                  {item.href ? (
                    <a href={item.href}>{item.text}</a>
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{ __html: item.text }}
                    ></span>
                  )}
                </dd>
              </React.Fragment>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

ContactForm.propTypes = propTypes;
export default ContactForm;
